import { IconArrowUpRight } from '@tabler/icons-react';

export default function Arrow() { return <IconArrowUpRight className="arrow" aria-hidden="true" size={18} stroke={1.7} />; }
